import enMessages from './en'
import thMessages from './th'

export default {
  en: {
    locale: 'en-US',
    messages: {
      ...enMessages
    }
  },
  th: {
    locale: 'th',
    messages: {
      ...thMessages
    }
  },
}